import React from 'react';
import Appearance from '../ImageAppearance/ImageAppearance';
import Conditions from '../ConditionGroup/PropertyConditions';

export default ({ activeTab, scaleImage, uploadFile, deleteImage }) => {
  return (
    <>
      {activeTab === 1 && (
        <Appearance scaleImage={scaleImage} uploadFile={uploadFile} deleteImage={deleteImage} />
      )}
      {activeTab === 3 && <Conditions />}
    </>
  );
};
